import {createApiAction} from "./subCustomerAction";

export const CLEAR_BILLING_DATA = "CLEAR_BILLING_DATA";
export const BILL_LIST = "BILL_LIST";
export const IS_BILL_LOADING = "IS_BILL_LOADING";
export const REQUEST_BILL_ERROR = "REQUEST_BILL_ERROR";
export const GST_DETAIL = "GST_DETAIL";
export const LINKED_ASSET_LIST = 'LINKED_ASSET_LIST';

export const getBillingList = (enqueueSnackbar, params, url, method) => {
    return createApiAction({
        url: url,
        method: method,
        params,
        returnFullResponse: true,
        actionTypes: {
            start: IS_BILL_LOADING,
            success: BILL_LIST,GST_DETAIL,
            failure: REQUEST_BILL_ERROR
        },
        messages: {
            error: "Failed to fetch Billing List"
        }
    })(enqueueSnackbar);
};

export const gstValidate = (enqueueSnackbar, params) => {
    return createApiAction({
        url: "/customer/add_billinig"  ,
        method: 'post' ,
        data: params,
        useFormData: true,
        returnFullResponse: true,
        messages: {
            success:"success",
            error: "Failed to add"
        },
    })(enqueueSnackbar);
};

export const getLinkedAssets = (enqueueSnackbar, params) => {
    return createApiAction({
        url: "/customer/linked_assets",
        method: "get",
        params,
        returnFullResponse: true,
        actionTypes: {
            start: IS_BILL_LOADING,
            success: LINKED_ASSET_LIST,
            failure: REQUEST_BILL_ERROR
        },
        messages: {
            error: "Failed to fetch Linked Assets"
        }
    })(enqueueSnackbar);
};